import React from 'react';
import { createPureComponent } from 'module/Common';

type Props<T> = {
  content: Array<T>;
  renderEmpty?: () => React.ReactElement<any>;
  renderSingle?: (item: T) => React.ReactElement<any>;
  renderMultiple?: (items: Array<T>) => React.ReactElement<any>;
};

export const Pluralized = createPureComponent<Props<any>>(
  'Pluralized',
  ({ content, renderEmpty, renderMultiple, renderSingle }) => {
    const size = content.length;
    if (size === 0) {
      return renderEmpty ? renderEmpty() : null;
    }
    if (size === 1) {
      return renderSingle ? renderSingle(content[0]) : null;
    }
    return renderMultiple ? renderMultiple(content) : null;
  }
);

export function createPluralized<D>(): React.ComponentClass<Props<D>> {
  return Pluralized;
}



// WEBPACK FOOTER //
// ./src/module/View/Common/component/Pluralized/index.tsx